export enum NotificationType {
  DOCUMENT_SHARE = "DOCUMENT_SHARE",
  SYSTEM = "SYSTEM",
  ALERT = "ALERT"
}

export interface NotificationModel {
  id: string;
  userId: string;
  title: string;
  message: string;
  type: NotificationType;
  isRead: boolean;
  metadata?: any;
  createdAt: string;
  updatedAt: string;
}


